module.exports = __webpack_public_path__ + "img/data.83cb1bca.gif";